<template lang="html">
	<section class="legals-layout take-place column">
		<div class="legals-master column">
			<div class="legals-title">
				Politique de confidentialité
			</div>
			<div class="legals-body">
				<div class="item">L’utilisation des données personnelles par Patrimoffice est encadrée principalement par le Règlement européen 2016-679 dit « Règlement Général sur la Protection des Données » ou « RGPD » et la loi n° 78-17 du 6 janvier 1978 modifiée, dite loi « Informatique et Libertés ».</div>
				<div class="item">Les informations recueillies sont enregistrées dans un fichier informatisé par Patrimoffice afin notamment de pouvoir proposer des produits et services de qualité personnalisés et adaptés à chaque situation patrimoniale, besoin et objectif recherché, se conformer à ses obligations légales et règlementaires et exercer son activité de conseil et de suivi au mieux des intérêts des clients. Elles sont conservées pendant la durée de la relation contractuelle et pendant 5 ans à l’issue de la relation et sont destinées aux établissements dépositaires ou compagnies d’assurance à partenaires de Patrimoffice, et le cas échéant à son prestataire de services informatiques. Ces données ne font l’objet d’aucune transmission à des organismes extérieurs notamment à des fins de prospection commerciale sans l’accord du client.</div>
				<div class="item">Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d’accès, d’opposition, d’effacement, de limitation du traitement, de portabilité des données vous concernant et les faire rectifier en contactant notre service de traitement des données à contact@patrimoffice.com. Vous pouvez également introduire une réclamation au sujet du traitement de vos données auprès de la CNIL.</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Confidentiality.vue?bfb4bb7c